import {
  Box,
  Container,
  IconButton,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TwitterIcon from "@mui/icons-material/X";
import BookIcon from "@mui/icons-material/Book";
import SiteIcon from "./Icon";

function Copyright() {
  return (
    <Typography variant="body2" sx={{ color: "text.secondary", mt: 1 }}>
      {"Copyright © "}
      <Link color="text.secondary" href="https://zehua-zeng.github.io/">
        Zehua Zeng
      </Link>
      &nbsp;
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: { xs: 4, sm: 8 },
        py: 10,
        textAlign: { sm: "center", md: "left" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          pt: 4,
          width: "100%",
          borderTop: "1px solid",
          borderColor: "divider",
        }}
      >
        <div>
          <a href="/">
            <SiteIcon />
          </a>
          <Stack
            direction="row"
            spacing={1}
            useFlexGap
            sx={{ justifyContent: "left", color: "text.secondary" }}
          >
            <IconButton
              color="inherit"
              size="small"
              href="https://www.instagram.com/sharkshooter2011/"
              aria-label="Instagram"
              sx={{ alignSelf: "center" }}
            >
              <InstagramIcon />
            </IconButton>
            <IconButton
              color="inherit"
              size="small"
              href="https://x.com/neki2011"
              aria-label="X"
              sx={{ alignSelf: "center" }}
            >
              <TwitterIcon />
            </IconButton>
            <IconButton
              color="inherit"
              size="small"
              href="https://www.youtube.com/@sharkshooter2011"
              aria-label="YouTube"
              sx={{ alignSelf: "center" }}
            >
              <YouTubeIcon />
            </IconButton>
            <IconButton
              color="inherit"
              size="small"
              href="https://www.facebook.com/muneki.samejima"
              aria-label="Facebook"
              sx={{ alignSelf: "center" }}
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              color="inherit"
              size="small"
              href="https://note.com/sharkshooter2011"
              aria-label="Note"
              sx={{ alignSelf: "center" }}
            >
              <BookIcon />
            </IconButton>
          </Stack>
        </div>
        <div style={{ textAlign: "right" }}>
          <Copyright />
        </div>
      </Box>
    </Container>
  );
}
